import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFace, MdOutlineFace3 } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM, GENDER } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import validation from "./validation";

function View({ contact, onNext, onBack, locked }) {
  const { t } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      ...contact,
      acceptContact: get(contact, "acceptContact") || false,
      acceptDigital: get(contact, "acceptDigital") || false,
      showTelecoms:
        get(contact, "user.firstname") && get(contact, "user.lastname"),
      showAccept:
        get(contact, "user.firstname") &&
        get(contact, "user.lastname") &&
        get(contact, `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`) &&
        get(contact, `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`),
      user: {
        ...get(contact, "user", {}),
        gender: get(contact, "user.gender") || GENDER.MALE,
      },
    },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  return (
    <Layout>
      <Header
        title="Presque fini ! Dernière étape pour découvrir votre offre personnalisée"
        highlight="Presque fini !"
        subtitle="Informations de l’adhérent"
        onBack={onBack}
      />

      <Row justify="center">
        <Col xs={24} md={18}>
          <div className="grid--1">
            <div className="grid--2">
              <Input
                label={"Civilité"}
                size="full"
                row
                type="radio"
                values={[
                  {
                    icon: <MdOutlineFace size={20} />,
                    value: GENDER.MALE,
                    label: "Homme",
                  },
                  {
                    icon: <MdOutlineFace3 size={20} />,
                    value: GENDER.FEMALE,
                    label: "Femme",
                  },
                ]}
                {...bindInputProps({
                  name: "user.gender",
                  values,
                  ...formProps,
                })}
                onChange={(value) => setFieldValue("user.gender", value)}
              />
            </div>
            <div className="grid--2">
              <Input
                placeholder={"ex : Doe"}
                label={"Nom"}
                {...bindInputProps({
                  name: "user.lastname",
                  values,
                  ...formProps,
                })}
                disabled={locked}
                onChange={({ target: { value } }) => {
                  setFieldValue("user.lastname", value);
                  setFieldValue(
                    "showTelecoms",
                    values.showTelecoms ||
                      !!(value && get(values, "user.firstname")),
                  );
                }}
              />
              <Input
                placeholder={"ex : John"}
                label={"Prénom"}
                {...bindInputProps({
                  name: "user.firstname",
                  values,
                  ...formProps,
                })}
                disabled={locked}
                onChange={({ target: { value } }) => {
                  setFieldValue("user.firstname", value);
                  setFieldValue(
                    "showTelecoms",
                    values.showTelecoms ||
                      !!(value && get(values, "user.lastname")),
                  );
                }}
              />
            </div>
            {values.showTelecoms && (
              <div className="grid--2">
                <Input
                  placeholder={"ex : 0610203040"}
                  label={"N° de téléphone"}
                  {...bindInputProps({
                    name: `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                    values,
                    ...formProps,
                  })}
                  disabled={locked}
                  onChange={({ target: { value } }) => {
                    setFieldValue(
                      `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                      value,
                    );
                    setFieldValue(
                      "showAccept",
                      values.showAccept ||
                        !!(
                          value &&
                          get(
                            values,
                            `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                          )
                        ),
                    );
                  }}
                />
                <Input
                  placeholder={"ex : email@email.com"}
                  label={"Email"}
                  {...bindInputProps({
                    name: `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                    values,
                    ...formProps,
                  })}
                  disabled={locked}
                  onChange={({ target: { value } }) => {
                    setFieldValue(
                      `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                      value,
                    );
                    setFieldValue(
                      "showAccept",
                      values.showAccept ||
                        !!(
                          value &&
                          get(
                            values,
                            `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                          )
                        ),
                    );
                  }}
                />
              </div>
            )}
            {values.showAccept && (
              <>
                <Input
                  type="checkbox"
                  label={
                    "En cochant cette case, j’accepte d’être rappelé par Amellis Mutuelles pour la vente d’un produit de complémentaire santé."
                  }
                  checked={get(values, "acceptContact") || false}
                  {...bindInputProps({
                    name: "acceptContact",
                    values,
                    ...formProps,
                  })}
                />

                <Input
                  type="checkbox"
                  label={
                    "En cochant cette case, j’accepte de recevoir par voie électronique des informations concernant les offres de produits et services d’Amellis Mutuelles, de ses filiales et de ses affiliés."
                  }
                  checked={get(values, "acceptDigital") || false}
                  {...bindInputProps({
                    name: "acceptDigital",
                    values,
                    ...formProps,
                  })}
                />
              </>
            )}
          </div>
        </Col>
      </Row>
      <ActionButtons
        onNext={handleSubmit}
        disabled={!get(values, "user.firstname") || !isEmpty(formProps.errors)}
        onBack={onBack}
      />
    </Layout>
  );
}

export default View;
